/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountManagerSearchResult} from '../models/AccountManagerSearchResult';
import type {Error} from '../models/Error';

export interface GetPossibleAccountManagers$Request {
    name?: string;
}

export interface GetPossibleAccountManagers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPossibleAccountManagersRequest = createAction<PayloadData<void, GetPossibleAccountManagers$Request>>('GET_ACCOUNT_POSSIBLE_MANAGER__GET_POSSIBLE_ACCOUNT_MANAGERS__REQUEST');
export const getPossibleAccountManagersSuccess = createAction<PayloadData<Array<AccountManagerSearchResult>, GetPossibleAccountManagers$Request>>('GET_ACCOUNT_POSSIBLE_MANAGER__GET_POSSIBLE_ACCOUNT_MANAGERS__SUCCESS');
export const getPossibleAccountManagersFailure = createAction<PayloadData<Error, GetPossibleAccountManagers$Request, true>>('GET_ACCOUNT_POSSIBLE_MANAGER__GET_POSSIBLE_ACCOUNT_MANAGERS__FAILURE');

export const getPossibleAccountManagersActions = [
    getPossibleAccountManagersRequest,
    getPossibleAccountManagersSuccess,
    getPossibleAccountManagersFailure
] as const;

/**
 * @param {string} [meta.name] Account manager first/last name or email
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPossibleAccountManagers = (meta: GetPossibleAccountManagers$Request, config?: GetPossibleAccountManagers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        name: meta.name,
    };
    return {
        CALL_API: {
            types: getPossibleAccountManagersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/account-managers/possible`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

